import { apiCall } from "./firebase";

export interface Agent {
  agentId: string;
  ownerId: string;
  name: string;
  type: string;
  permissions: {
    agentId: string;
    canProposeActions: string[];
    canExecuteActions: string[];
    subscribedEvents: string[];
    allowedSources: string[];
  };
  createdAt: string;
  updatedAt: string;
}

export interface AgentPermissions {
  agentId: string;
  canProposeActions: string[];
  canExecuteActions: string[];
  subscribedEvents: string[];
}

export class UserService {
  /**
   * Get all agents for the current user
   */
  async getUserAgents(): Promise<Agent[]> {
    try {
      console.log("UserService: Getting user agents...");
      const response = await apiCall("/getAgentsForUser");
      console.log("UserService: User agents retrieved:", response.agents);
      return response.agents;
    } catch (error) {
      console.error("UserService: Failed to get user agents:", error);
      throw error;
    }
  }

  /**
   * Update permissions for a specific agent
   */
  async updateAgentPermissions(agentId: string, permissions: AgentPermissions): Promise<void> {
    try {
      console.log("UserService: Updating agent permissions...", { agentId, permissions });
      await apiCall("/updateAgentPermissions", {
        method: "POST",
        body: JSON.stringify({ agentId, permissions }),
      });
      console.log("UserService: Agent permissions updated successfully");
    } catch (error) {
      console.error("UserService: Failed to update agent permissions:", error);
      throw error;
    }
  }

  /**
   * Reset agent permissions to default
   */
  async resetAgentPermissions(agentId: string): Promise<void> {
    try {
      console.log("UserService: Resetting agent permissions...", { agentId });
      await apiCall("/resetAgentPermissions", {
        method: "POST",
        body: JSON.stringify({ agentId }),
      });
      console.log("UserService: Agent permissions reset successfully");
    } catch (error) {
      console.error("UserService: Failed to reset agent permissions:", error);
      throw error;
    }
  }
}

// Export a singleton instance
export const userService = new UserService();
